/**
 * Manual reviews carousel.
 *
 * Uses slick-carousel, which the theme already bundles for its other sliders —
 * no new dependency, and it animates with transforms rather than scrollLeft,
 * matching how the Yotpo carousel (Glide) behaves.
 *
 * Inert on pages with no .rcm-slider.
 */

// Wrapped so nothing inside becomes a global binding. That matters because a
// top-level `function initRcmSliders(){}` IS `window.initRcmSliders` in a
// classic script, so exposing a wrapper under that name would rebind the
// identifier and make the wrapper's internal call recurse into itself.
(function () {
  function initRcmSliders() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;

    $('.rcm-slider').each(function () {
      var $slider = $(this);
      if ($slider.hasClass('slick-initialized')) return;

      var $root = $slider.closest('[data-rcm]');
      var autoplay = $root.attr('data-rcm-autoplay') === 'true';
      var speed = parseInt($root.attr('data-rcm-speed'), 10);
      if (isNaN(speed) || speed < 1000) speed = 3000;

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      $slider.slick({
        // Yotpo/Glide uses fixed-width slides with a partial peek at every
        // breakpoint rather than a responsive slidesToShow, so variableWidth
        // lets the card's own CSS width drive how many are visible.
        variableWidth: true,
        // Yotpo centres the active card, so a sliver of the previous and next
        // card shows on BOTH sides at every breakpoint.
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: false,
        swipeToSlide: true,
        autoplay: autoplay && !reduceMotion,
        autoplaySpeed: speed,
        pauseOnHover: true,
        pauseOnFocus: true,
        prevArrow: $root.find('.rcm-prev'),
        nextArrow: $root.find('.rcm-next')
        // Arrow visibility is CSS's job, not slick's. A responsive override
        // here would be inverted under mobileFirst (a 768 breakpoint applies
        // ABOVE 768), and toggling `arrows` per breakpoint leaves slick's
        // handlers bound to elements it has stopped managing. CSS hides them
        // below 768, which is where the Yotpo carousel is swipe-only.
      });
    });
  }


  /**
   * "Read more" - Yotpo truncates the review before it renders, so its link
   * sits inline after an ellipsis. We reproduce that by trimming whole words
   * until the copy plus the link fits the clamped box, which keeps the cut on
   * a word boundary instead of slicing through one.
   */
  function fitRcmBody(card, textEl, wrapEl, body) {
    var full = textEl.getAttribute('data-rcm-full');
    if (full === null) {
      full = textEl.textContent;
      textEl.setAttribute('data-rcm-full', full);
    }

    // Measure against the full copy first: if it already fits, no link at all.
    textEl.textContent = full;
    wrapEl.hidden = true;
    if (body.scrollHeight <= body.clientHeight + 1) return;

    wrapEl.hidden = false;
    var words = full.split(/\s+/);

    // Largest word count that still fits, by binary search.
    var lo = 0, hi = words.length, best = 0;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      textEl.textContent = words.slice(0, mid).join(' ');
      if (body.scrollHeight <= body.clientHeight + 1) { best = mid; lo = mid + 1; }
      else { hi = mid - 1; }
    }
    textEl.textContent = words.slice(0, best).join(' ').replace(/[\s.,;:!?-]+$/, '');
  }

  function initRcmReadMore(root) {
    var cards = (root || document).querySelectorAll('.rcm-card');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var body = card.querySelector('.rcm-body');
        var textEl = card.querySelector('[data-rcm-text]');
        var wrap = card.querySelector('[data-rcm-readmore-wrap]');
        var btn = card.querySelector('[data-rcm-readmore]');
        if (!body || !textEl || !wrap || !btn) return;

        // How many lines clamp depends on the card's width, which changes with
        // the breakpoint - so re-fit rather than trusting the first pass.
        if (!card.classList.contains('is-expanded')) fitRcmBody(card, textEl, wrap, body);

        if (btn.dataset.rcmBound === 'true') return;
        btn.dataset.rcmBound = 'true';
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            textEl.textContent = textEl.getAttribute('data-rcm-full') || textEl.textContent;
            btn.textContent = 'Read less';
          } else {
            btn.textContent = 'Read more';
            fitRcmBody(card, textEl, wrap, body);
          }
        });
      })(cards[i]);
    }
  }

  var rcmResizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(rcmResizeTimer);
    rcmResizeTimer = window.setTimeout(function () { initRcmReadMore(); }, 150);
  });

  function initRcmAll() {
    initRcmSliders();
    initRcmReadMore();
  }

  window.initRcmSliders = initRcmAll;

  document.addEventListener('shopify:section:load', function () {
    // let the section's markup settle before slick measures it
    window.setTimeout(initRcmAll, 50);
  });

  // Theme editor: selecting a review block should bring that card into view,
  // and editing one shouldn't leave the merchant looking at a different slide.
  // slick promotes each block wrapper to .slick-slide in place, so the element
  // Shopify fires on IS the slide and carries the authoritative data-slick-index
  // (jQuery .index() would count the clones infinite mode inserts).
  function rcmSlideContext(e) {
    var el = e.target;
    if (!window.jQuery || !el || !el.closest) return null;
    var slider = el.closest('.rcm-slider');
    if (!slider || slider.className.indexOf('slick-initialized') === -1) return null;
    return { $slider: window.jQuery(slider), slide: el.closest('.slick-slide') };
  }

  document.addEventListener('shopify:block:select', function (e) {
    var ctx = rcmSlideContext(e);
    if (!ctx) return;
    ctx.$slider.slick('slickPause');
    if (!ctx.slide) return;
    var index = parseInt(ctx.slide.getAttribute('data-slick-index'), 10);
    if (!isNaN(index)) ctx.$slider.slick('slickGoTo', index);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var ctx = rcmSlideContext(e);
    if (ctx) ctx.$slider.slick('slickPlay');
  });
})();
